// Module
var code = "<a class=\"text-sm sps-btn sps-btn-outline btn-color-recipe-editor recipeEditorBtn disabled\"> <i class=\"fa fa-indent\"></i>recipe editor </a>";
// Exports
export default code;